let $ = jQuery;

const servicesPhotosSlider = () => {
    var swiper1 = new Swiper('.services-photos-slider', {
        navigation: {
            nextEl: '.services-photos-slider .swiper-button-next',
            prevEl: '.services-photos-slider .swiper-button-prev',
        },
        breakpoints: {
            0: {
                slidesPerView: 1.2,
                spaceBetween: 30,
            },
            500: {
                slidesPerView: 2.2,
                spaceBetween: 30,
            },
            992: {
                spaceBetween: 30,
                slidesPerView: 3,
            }
        }
    });
}
const flyTable = () => {
    var swiper = new Swiper('.fly-table', {
        slidesPerView: 2,
        spaceBetween: 30,
        navigation: {
            nextEl: '.fly-table .swiper-button-next',
            prevEl: '.fly-table .swiper-button-prev',
        },
    });
}
const mainBaner = () => {
    var swiper = new Swiper('.main-banner .swiper', {
        slidesPerView: 1,
        navigation: {
            nextEl: '.main-banner .swiper .swiper-button-next',
            prevEl: '.main-banner .swiper .swiper-button-prev',
        },
    });
}
const testimonials = () => {
    var swiper = new Swiper('.testimonials', {
        speed: 800,
        navigation: {
            nextEl: '.testimonials .swiper-button-next',
            prevEl: '.testimonials .swiper-button-prev',
        },
    });
}

const header = () => {
    $(window).on('scroll',function () {
        if ($(this).scrollTop() > 1) {
            $('#header').addClass("sticky");
            $('.scrollToTop').addClass('active');
        } else {
            $('#header').removeClass("sticky");
            $('.scrollToTop').removeClass('active');
        }
    });
    $('#header .nav-menu--item').each(function () {
        let $this = $(this),
            submenu = $this.find('.nav-menu--sub');
        if(submenu.length){
            $this.addClass('has-submenu');
            $this.find('> .nav-menu--link').append('<span class="nav-menu--link--arrow"></span>');
        }
    });
    $('.js-bugger-menu').on('click', function() {
        $(this).toggleClass('active');
        $('.overlay').fadeIn();
        $('.js-header-menu').toggleClass('active');
        $('#header .logo').toggleClass('active');
    });
    $('.nav-menu-close-icon, .overlay').on('click', function() {
        $('.js-bugger-menu, .js-header-menu').toggleClass('active');
        $('.overlay').fadeOut();
        $('#header .logo').toggleClass('active');
    });
    $('.nav-menu--item > .nav-menu--link').on('click', function() {
        $(this).next().slideToggle();
        $(this).toggleClass('active');
    })
}

const toggle = () => {
    $('.toggleBlock .toggle__item .toggle__head').on('click', function () {
        $(this).toggleClass('active');
        $(this).next().slideToggle();
    });
}


const paymentMethod = () => {
    $('.payment-form .form-item input').on('change', function () {
        
        let name = $(".payment-form .form-item input:checked").attr('id');
        $('.payment-form-method > .item').hide();
        $(`.payment-form-method .item[data-method="${name}"]`).fadeIn();
        
    });
}

const stickySupport = () => {
    $('.sticky-support .button').on('click', function () {
        $('.sticky-support').toggleClass('active');
    });
}
const viewPayment = () => {
    $('.view-payment .button').on('click', function (e) {
        e.preventDefault();
        $(this).toggleClass('active');
        $('.view-payment-content').slideToggle();
    });
}
$(document).ready(function () {
    servicesPhotosSlider();
    flyTable();
    testimonials();
    toggle();
    header();
    paymentMethod();
    stickySupport();
    viewPayment();
    mainBaner();
    $('select').select2({
        minimumResultsForSearch: -1
    });
    if ($(window).scrollTop() > 1) {
        $('#header').addClass("sticky");
        $('.scrollToTop').addClass('active');
    } else {
        $('#header').removeClass("sticky");
        $('.scrollToTop').removeClass('active');
    }
    $('.scrollToTop').on('click', function () {
        $('html, body').animate({
            scrollTop: 0
        }, 800);
        return false;
    });
});